export default function areArraysIdentical(array1, array2) {
  if (array1.length !== array2.length) return false;

  const array1Sorted = array1.slice().sort();
  const array2Sorted = array2.slice().sort();

  return array1Sorted.every((value, index) => value === array2Sorted[index]);
}
